export default {
  baseCoreURL: process.env.VUE_APP_CHAT_BASEURL ?? "https://liquidweb--SCDEV.my.salesforce.com",
  communityEndpointURL:
    process.env.VUE_APP_CHAT_COMMUNITYURL ?? "https://scdev-liquidweb.cs91.force.com/public",
  gslbBaseURL: process.env.VUE_APP_CHAT_GSLBURL ?? "https://service.force.com",
  orgId: process.env.VUE_APP_CHAT_ORGID ?? "00D2F0000009BrP",
  eswConfigDevName: process.env.VUE_APP_CHAT_CONFIGDEVNAME ?? "Nexcess_Portal",
  settings: {
    baseLiveAgentContentURL:
      process.env.VUE_APP_CHAT_CONTENTURL ??
      "https://c.la4-c1cs-phx.salesforceliveagent.com/content",
    deploymentId: process.env.VUE_APP_CHAT_DEPLOYMENTID ?? "5720c0000004aCZ",
    buttonId: process.env.VUE_APP_CHAT_BUTTONID ?? "5732F0000008Ttg",
    baseLiveAgentURL:
      process.env.VUE_APP_CHAT_AGENTURL ?? "https://d.la4-c1cs-phx.salesforceliveagent.com/chat",
    eswLiveAgentDevName:
      process.env.VUE_APP_CHAT_AGENTDEVNAME ??
      "EmbeddedServiceLiveAgent_Parent04I2F0000004CULUA2_17493029b44",
    isOfflineSupportEnabled: process.env.VUE_APP_CHAT_OFFLINEENABLED ?? false,
    chatbotAvatarImgURL:
      process.env.VUE_APP_CHAT_AGENTICON ?? require("@/assets/nexcess-logo-square-200px.png"),
  },
  eswScriptURL:
    process.env.VUE_APP_CHAT_SCRIPTURL ??
    "https://liquidweb--SCDEV.my.salesforce.com/embeddedservice/5.0/esw.min.js",
  displayHelpButton: process.env.VUE_APP_CHAT_DISPLAYBUTTON ?? false,
  storageDomain: process.env.VUE_APP_CHAT_STORAGEDOMAIN ?? "localhost",
  chatStartTimeout: process.env.VUE_APP_CHAT_TIMEOUT ?? 30000,
  analyticsMode: process.env.VUE_APP_CHAT_ANALYTICSMODE ?? "dataLayer",
  analyticsActionContext: process.env.VUE_APP_CHAT_ANALYTICSCONTEXT ?? "nx",
  useGoogleAnalytics: process.env.VUE_APP_CHAT_ENABLEGA ?? true,
  googleAnalyticsTrackerTimeout: process.env.VUE_APP_CHAT_GATIMEOUT ?? 2500,
  preselectDepartment: process.env.VUE_APP_CHAT_PRESELECTDEPARTMENT ?? null,
};
